export default __webpack_public_path__ + "4bc353b98f6ac37b1130c1608e507d00.png";